import { Injectable } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable()
export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any): any {
    const config = {
      required: 'This field is required.',
      invalidCreditCard: 'Is invalid credit card number.',
      invalidEmailAddress: 'Please enter a valid email address. For example abc@domain.com.',
      invalidPassword: 'Invalid password. Password must be within 4-50 non white space characters and at least one number',
      minlength: `This field is required to be at least ${validatorValue.requiredLength} characters.`,
      maxlength: `This field cannot be longer than ${validatorValue.requiredLength} characters.`,
      min: `This field should be at least ${validatorValue.min}.`,
      max: `This field cannot be more than ${validatorValue.max}.`,
      email: `Please enter a valid email address. For example abc@domain.com.`,
      invalidZip: 'Invalid zip code. Input 5 or 9 digit number.',
      invalidAshaNumber: 'Invalid ASHA number. Input 8 digit number.',
      invalidColor: 'Invalid color.',
      invalidMinTime: `This field should be at least ${validatorValue.minValue}`,
      invalidMaxTime: `This field cannot be more than ${validatorValue.maxValue}`,
      commonError: `${validatorValue.msg}`,
      invalidCharacter: 'Please enter valid character'
    };
    return config[validatorName];
  }

  static creditCardValidator(control: FormControl): any {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    if (
      control.value.match(
        /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
      )
    ) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  static emailValidator(control: FormControl): any {
    // RFC 2822 compliant regex
    if (
      control &&
      control.value &&
      control.value.match(
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      )
    ) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }

  static passwordValidator(control: FormControl): any {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value && control.value.trim()) {
      if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{4,50}$/)) {
        return null;
      } else {
        return { invalidPassword: true };
      }
    }
  }

  static zipCode(control: FormControl): any {
    if (control.value && control.value.trim()) {
      if (control.value.match(/^[0-9]{5}(-[0-9]{4})?$/)) {
        return null;
      } else {
        return { invalidZip: true };
      }
    } else {
      return null;
    }
  }

  static ashaNumber(control: FormControl): any {
    if (control.value && control.value.trim()) {
      if (control.value.match(/^[0-9]{8}?$/)) {
        return null;
      } else {
        return { invalidAshaNumber: true };
      }
    } else {
      return null;
    }
  }

  static colorPickerValidator(control: FormControl): any {
    if (control.value && control.value.trim()) {
      if (control.value.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
        return null;
      } else {
        return { invalidColor: true };
      }
    } else {
      return null;
    }
  }

  static maxStringValue(maxValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && maxValue && control.value > maxValue) {
        return { max: { max: maxValue } };
      }
      return null;
    };
  }

  static minStringValue(minValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && minValue && control.value < minValue) {
        return { min: { min: minValue } };
      }
      return null;
    };
  }

  static commonValidation(isError: boolean, msg?: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && isError) {
        return { commonError: { msg } };
      }
      return null;
    };
  }

  
  static specialCharacterValidator(control: FormControl): any {
    // RFC 2822 compliant regex
    if (
      control &&
      control.value &&
      control.value.match(/^[\w`'\-\r\n]+$/g)
    ) {
      return null;
    } else if(!control.value || 
              control.value &&
              control.value === ''){
      return null;
    } else {
      return { invalidCharacter: true };
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/components/control-messages/validation.service.ts